$(document).on('click', '.form-unsubscribe [type="submit"]', function(e) {

  e.preventDefault();

  var $form = $(this).parents('form');

  $.ajax({
    url: customSettings.ajaxurl,
    method: 'POST',
    data: {
      action: 'form_unsubscribe',
      email: $form.find('[name="email"]').val(),
      _wpnonce: $form.find('[name="_wpnonce"]').val()
    },
    dataType: 'json',
    success: function(response) {
      if (response.status === 'success') {
        $form.append('<span class="submit-message success">'+response.message+'</span>');
      } else {
        $form.append('<span class="submit-message error">'+response.message+'</span>');
      }
    }
  });

});